import { Box, Container } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Headings from "./../../../common/headings/headings";
import ProjectItem from "./../projectItem/projectItem";
import apiProjects from "../../../../core/api/projects/api.projects";
import Skeleton from "../../../common/skeleton/skeleton";
import Disclamier from "../../../common/disclamier/disclamier";
import ChromaGrid from "../../../common/bits/chroma-grid";

export default function ViewAll() {
  const [data, setProject] = useState([]);
  // const dataUrl = "../assets/data/projects.json"
  const getData = async () => {
    try {
      let projects = await apiProjects.getfbProjects();
      setProject(projects);
    } catch (error) {}
  };
  useEffect(() => {
    getData();
  }, []);

  const item = () => {
    return (
      // <div style={{ position: "relative" }}>
      <ChromaGrid items={data} radius={300} damping={0.45} fadeOut={0.6} ease="power3.out" />
      // </div>

      // data.map((value, key) => (
      //     <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
      //         <div className="ui-glassmoprhic-bg ui-height--full ui-glass-shadow ui-border--r8">
      //             <Box p={4}>
      //                 <ProjectItem project={value} index={key}></ProjectItem>
      //             </Box>
      //         </div>
      //     </Grid>
      // ))
    );
  };

  return (
    <div className="ui-position--relative">
      <div className="ui-position--relative ui-padding--v-36 ui-z-index--1">
        <Box display="flex" flexDirection="column">
          <Container maxWidth="lg">
            <Headings heading="projects"></Headings>
            <div className="ui-padding--12"></div>
          </Container>
          <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="stretch">
            {data && data?.length > 0
              ? item()
              : [1, 2, 3, 4].map((value, key) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                    <Skeleton></Skeleton>
                  </Grid>
                ))}
          </Grid>
          <div className="ui-padding--16"></div>
        </Box>
        <Container maxWidth="lg">
          <div className="ui-padding--36"></div>
          <Disclamier></Disclamier>
        </Container>
      </div>
    </div>
  );
}
